angular.module('webcomm').directive('clickOutside', ['$document', '$log', function ($document, $log) {
    return {
        link: function (scope, elem, attrs) {

            var onClick = function (event) {
                // ignore clicks on the the toggle link or children
                var ngclick = event.target.getAttribute('ng-click');
                var targetAttribute = '[ng-click="' + attrs.clickOutside + '"]';
                var isToggle = $(event.target).closest(targetAttribute).length > 0;

                // ignore child links
                var isChild = $(elem).has(event.target).length > 0;
                var isSelf = elem[0] == event.target;

                // call toggle
                var isInside = isChild || isSelf || isToggle;
                if (!isInside) {
                    scope.$apply(attrs.clickOutside);
                }

            }

            scope.$on('$destroy', function () {
                $document.unbind('click', onClick);
            });

            $document.bind('click', onClick);
        }
    };
}]);